const replacePathnameLanguage = ({
  pathname,
  paramsLanguage,
  updatedLanguage,
}: {
  pathname: string;
  paramsLanguage: string;
  updatedLanguage: string;
}): string => {
  // replace any part of the pathname that is `/${paramsLanguage}/`
  let newPath = pathname.replaceAll(`/${paramsLanguage}/`, `/${updatedLanguage}/`);
  // if pathname ends with `/${paramsLanguage}` replace that
  if (newPath.endsWith(`/${paramsLanguage}`)) {
    newPath = newPath.slice(0, -paramsLanguage.length) + updatedLanguage;
  }

  return newPath;
};

export default replacePathnameLanguage;
